module.exports = __webpack_public_path__ + "media/39.9190085c.wav";